import * as sgqr from 'sgqr';
export class PayNowProvider {
    payeeInfo;
    constructor(payeeInfo) {
        this.payeeInfo = payeeInfo;
    }
    async generateQR(params) {
        try {
            // Use the general generate function instead of generate_svg to handle type strictness
            const sgqrData = sgqr.generate({
                number: this.payeeInfo.value, // Type cast for now due to strict SGQR types
                number_type: this.payeeInfo.type,
                amount: params.amount,
                merchant_name: this.payeeInfo.recipientName,
                comments: params.reference,
            });
            // For now, return the SGQR string - we can generate QR code on the frontend
            if (!sgqrData) {
                throw new Error('Failed to generate SGQR data');
            }
            return sgqrData;
        }
        catch (error) {
            console.error('Failed to generate PayNow QR:', error);
            throw new Error('Failed to generate PayNow QR code');
        }
    }
    validatePayeeInfo() {
        if (this.payeeInfo.type === 'MOBILE') {
            return /^\+65[0-9]{8}$/.test(this.payeeInfo.value);
        }
        if (this.payeeInfo.type === 'UEN') {
            return /^[0-9]{9,10}[A-Z]$/.test(this.payeeInfo.value);
        }
        return false;
    }
    static validatePayeeInfo(info) {
        if (info.type === 'MOBILE') {
            return /^\+65[0-9]{8}$/.test(info.value);
        }
        if (info.type === 'UEN') {
            return /^[0-9]{9,10}[A-Z]$/.test(info.value);
        }
        return false;
    }
}
